import React, { useReducer, createContext, useContext } from "react";
import { gameReducer, initialGameState } from "./hooks/useGameState";

const GameStateContext = createContext(null);

export const useGameStateContext = () => {
  const ctx = useContext(GameStateContext);
  if (!ctx) throw new Error("useGameStateContext must be used within GameStateProvider");
  return ctx;
};

const GameStateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, dispatch] = useReducer(gameReducer, initialGameState);

  return (
    <GameStateContext.Provider value={{ state, dispatch }}>
      {children}
    </GameStateContext.Provider>
  );
};

export default GameStateProvider;
